import {
  Box,
  CircularProgress,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { cloneElement, useContext, useEffect, useState } from "react";
import { RequestContext } from "../../context/request.context";
import { IoIosArrowForward } from "react-icons/io";
import { AiOutlineNumber } from "react-icons/ai";
import RegionComponent from "./components/region";
import moment from "moment/moment";
import ManagerComponent from "./components/manager";
import ClientComponent from "./components/client";
import Trades from "../trades/trade";
import {
  MdCalendarToday,
  MdFormatListNumbered,
  MdFullscreen,
  MdOutlineAttachMoney,
  MdOutlinePriceChange,
  MdPeople,
  MdPriceCheck,
} from "react-icons/md";
import { IoLocation, IoPerson } from "react-icons/io5";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import Products from "./components/products";

const topBarLabels = [
  [
    {
      label: "Region",
      align: "left",
      icon: <IoLocation />,
    },
    {
      label: "Managerlar soni",
      align: "center",
      icon: <IoPerson />,
    },
    {
      label: "Buyurtmalar soni",
      align: "center",
      icon: <MdFormatListNumbered />,
    },
    {
      label: "Savdo Summasi",
      align: "center",
      icon: <RiMoneyDollarCircleLine />,
    },
    {
      label: "To'lov Summasi",
      align: "center",
      icon: <MdOutlineAttachMoney />,
    },
    {
      label: "Fakt Summasi",
      align: "center",
      icon: <MdOutlineAttachMoney />,
    },
  ],
  [
    {
      label: "Manager",
      align: "left",
      icon: <IoPerson />,
    },
    {
      label: "Buyurtmalar soni",
      align: "center",
      icon: <MdFormatListNumbered />,
    },
    {
      label: "Savdo Summasi",
      align: "center",
      icon: <RiMoneyDollarCircleLine />,
    },
    {
      label: "To'lov Summasi",
      align: "center",
      icon: <MdOutlineAttachMoney />,
    },
    {
      label: "Fakt Summasi",
      align: "center",
      icon: <MdPriceCheck />,
    },
    {
      label: "Batafsil",
      align: "center",
      icon: <MdFullscreen />,
    },
    {
      label: "Mijozlar",
      align: "center",
      icon: <MdPeople />,
    },
  ],
  [
    {
      label: "Mijoz",
      align: "left",
      icon: <IoPerson />,
    },
    {
      label: "Buyurtma vaqti",
      align: "center",
      icon: <MdCalendarToday />,
    },
    {
      label: "Savdo Summasi",
      align: "center",
      icon: <RiMoneyDollarCircleLine />,
    },
    {
      label: "To'lov Summasi",
      align: "center",
      icon: <RiMoneyDollarCircleLine />,
    },
    {
      label: "Fakt Summasi",
      align: "center",
      icon: <MdOutlineAttachMoney />,
    },
  ],
  [
    {
      label: "Buyurtma nomi",
      align: "left",
      icon: <MdFormatListNumbered />,
    },
    {
      label: "Buyurtma soni",
      align: "center",
      icon: <MdFormatListNumbered />,
    },
    {
      label: "Buyurtma narxi",
      align: "center",
      icon: <MdOutlineAttachMoney />,
    },
    {
      label: "Jami Summasi",
      align: "center",
      icon: <RiMoneyDollarCircleLine />,
    },
    {
      label: "Fakt soni",
      align: "center",
      icon: <AiOutlineNumber />,
    },
    {
      label: "Fakt narxi",
      align: "center",
      icon: <MdOutlinePriceChange />,
    },
    {
      label: "Fakt Summasi",
      align: "center",
      icon: <MdPriceCheck />,
    },
  ],
];

const RenderRouter = ({ router, setRoutes, setCurrentComponent }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        bgcolor: "background.paper",
        border: 1,
        borderColor: "divider",
        borderRadius: 2,
        overflow: "hidden",
        width: "fit-content",
        transition: "all 0.3s ease",
      }}
    >
      {router.map((e, i) => (
        <Box key={i} sx={{ display: "flex", flexDirection: "row" }}>
          <Box
            key={i}
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              cursor: "pointer",
              padding: "10px",
              "&:hover": {
                bgcolor: "background.paper",
              },
            }}
            role="button"
            onClick={() => {
              setCurrentComponent(e.route);
              setRoutes((prev) => {
                return prev.slice(0, i + 1);
              });
            }}
          >
            <Typography>{e.label}</Typography>
          </Box>
          <IconButton size="small" disabled>
            {i !== router.length - 1 && <IoIosArrowForward />}
          </IconButton>
        </Box>
      ))}
    </Box>
  );
};

const TopBar = ({ labels = [] }) => {
  return (
    labels.length > 0 && (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          bgcolor: "background.paper",
          border: 1,
          borderColor: "divider",
          borderRadius: 2,
          color: "text.secondary",
          fontWeight: 600,
          padding: "10px",
          transition: "all 0.3s ease",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "10px",
            width: "100%",
          }}
        >
          {labels.map((e, i) => (
            <Box
              width={"100%"}
              key={i}
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "10px",
                justifyContent: e.align,
              }}
            >
              {e.icon}
              <Typography>{e.label}</Typography>
            </Box>
          ))}
        </Box>
        <Box width={"40px"}></Box>
      </Box>
    )
  );
};

const TestReportPage = () => {
  const { request } = useContext(RequestContext);
  const start = moment().startOf("month").format("YYYY-MM-DD");
  const end = moment().endOf("month").format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);
  const [currentComponent, setCurrentComponent] = useState(<></>);
  const [routes, setRoutes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    request(
      `/region/all/full?desc=true&size=100&from=${startDate}&to=${endDate}`,
      "GET"
    ).then((res) => {
      setLoading(false);
      setCurrentComponent(<RegionComponent />);
      setRoutes([
        {
          label: "Region",
          route: "Region",
          data: res.filter((data) => {
            const user = JSON.parse(localStorage.getItem("user"));
            const {
              region: { id },
            } = user;
            const role = user.role;
            if (role === "ADMIN" || role === "DIRECTOR") return true;
            return data.region.id === id;
          }),
          component: <RegionComponent />,
        },
      ]);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  const component = (name) => {
    switch (name) {
      case "Region":
        return <RegionComponent />;
      case "Manager":
        return <ManagerComponent />;
      case "Klient":
        return <ClientComponent />;
      case "Buyurtmalar":
        return <Products />;
      case "Savdo":
        return <Trades />;
      default:
        return <></>;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <RenderRouter
          router={routes}
          setRoutes={setRoutes}
          setCurrentComponent={(route) => {
            setCurrentComponent(component(route));
          }}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <TextField
            type="date"
            value={startDate}
            onChange={async (e) => {
              setStartDate(e.target.value);
            }}
            size="small"
            label="Boshlang'ich vaqt"
          />
          <TextField
            type="date"
            value={endDate}
            onChange={async (e) => {
              setEndDate(e.target.value);
            }}
            size="small"
            label="Oxirgi vaqt"
          />
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        {!loading ? (
          <>
            <TopBar labels={topBarLabels[routes.length - 1]} />
            {cloneElement(currentComponent, {
              data: routes[routes.length - 1]?.data,
              action: (route, data) => {
                setRoutes((prev) => {
                  return [
                    ...prev,
                    {
                      label: route,
                      route: route,
                      data,
                      component: component(route),
                    },
                  ];
                });
                setCurrentComponent(component(route));
              },
              times: {
                from: startDate,
                to: endDate,
              },
            })}
          </>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: "80vh",
            }}
          >
            <CircularProgress />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default TestReportPage;
